import * as React from 'react';
import { ComplexValue } from '../common/types';
import styles from './button-list.scss';

export interface ButtonListButtonProps {
  name: string;
  option: ComplexValue<number>;
  onChange: any;
  isSelected: boolean;
}

export class ButtonListButton extends React.Component<ButtonListButtonProps, any> {

  public onChange = () => {
      this.props.onChange(this.props.option);
  };

  public render() {
    return(
      <div className={`btn ${styles.statusSelectorOption}`}>
        <input type="radio"
        className={`form-check-input form-inline visuallyhidden ${this.props.isSelected ? styles.active : ''}`}
        name={this.props.name}
        value={this.props.option.value}
        checked={this.props.isSelected}
        onChange={this.onChange}
        id={`status-select-${this.props.name}-${this.props.option.value}`}/>
        <label
          htmlFor={`status-select-${this.props.name}-${this.props.option.value}`}
          aria-pressed={this.props.isSelected ? 'true' : 'false'}>
          {this.props.option.description}
        </label>
      </div>
    );
  }
}
